import { Component, Prop, mixins, namespace } from 'nuxt-property-decorator'
import { IProduct } from '~/assets/interfaces/products'
import MixinGeneral from '~/assets/mixins/general'
import { paddingTopFromRatio } from '~/assets/functions/ratio'

const siteStore = namespace('site')

// Общее для всех вариантов карточки товара (product-item-1…5,
// m-product-item-3): переключение фото по наведению и свайпу, alt/title
// первого фото, распорка под картинку, опции оформления с бэка. Сами
// варианты оставляют себе только раскладку.
@Component
export default class MixinProductCard extends mixins(MixinGeneral) {
  @Prop({ type: Object, default: () => ({}) }) public item!: IProduct

  // Показывать ли кнопку избранного. Страницы передают его всем вариантам
  // через динамический компонент, часть вариантов его не использует.
  @Prop({ type: Boolean, default: false }) public favourite!: boolean

  // Соотношение сторон от родителя (слайдер) — важнее, чем у товара.
  @Prop({ type: String, default: null }) public aspectRatio!: string | null

  @siteStore.Getter('getOptionsProductImageBackdrop')
  public isImageBackdrop!: boolean

  @siteStore.Getter('getOptionsProductShadow')
  public isProductShadow!: boolean

  public imageNumber = 0

  // Размытое превью показываем до первого переключения фото.
  public isHiddenImageLazyLoad = false

  public get imagesAmount() {
    return this.item.images ? this.item.images.length : 0
  }

  // num — номер фото с единицы; за пределами списка — ближайшее крайнее.
  public hover(num: number) {
    this.isHiddenImageLazyLoad = true
    const clamped = Math.min(Math.max(num, 1), Math.max(this.imagesAmount, 1))
    this.imageNumber = clamped - 1
  }

  public swipeMobile(direction: string) {
    if (direction === 'left') {
      this.hover(this.imageNumber + 2)
    }
    if (direction === 'right') {
      this.hover(this.imageNumber)
    }
  }

  // alt/title заданы только для первого фото.
  public get imageAlt() {
    if (this.imageNumber !== 0 || !this.item.imageMeta) {
      return null
    }
    return this.item.imageMeta.alt || null
  }

  public get imageTitle() {
    if (this.imageNumber !== 0 || !this.item.imageMeta) {
      return null
    }
    return this.item.imageMeta.title || null
  }

  public get styleImage() {
    const style: Record<string, string> = {}
    const paddingTop = paddingTopFromRatio(this.aspectRatio || this.item.ratio)
    if (paddingTop) {
      style.paddingTop = paddingTop
    }
    // С подложкой превью не рисуем: размытая копия фоном спорила бы с ней.
    if (
      this.item.imageLazyLoad &&
      !this.isHiddenImageLazyLoad &&
      !this.isImageBackdrop
    ) {
      style.backgroundImage = `url("${this.item.imageLazyLoad}")`
    }
    return style
  }

  public mounted(): void {
    this.$emit('loaded')
  }
}
